module.exports = new __parcel__URL__("machines_bp_star_wolvez_helmet_cosmetic_level_1.4804ba62.png").toString();